import { render, staticRenderFns } from "./GeneSummary.vue?vue&type=template&id=68a3a73a&"
import script from "./GeneSummary.vue?vue&type=script&lang=js&"
export * from "./GeneSummary.vue?vue&type=script&lang=js&"
import style0 from "./GeneSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports